import * as types from '../actions/action-types';
import _ from 'lodash';

const stateAbbrKey = 'sa';

const countyFipsKey = 'cf';
const countyNameKey = 'cn';

const defaults = {
  loading: true,
  loadingPct: true,
  selected: {
    name: 'Autauga',
    state: 'AL',
    fips: 1001
  },
  list: [],
  data: [],
  dict: {},
  percentiles: [],
  percentileDict: {}
};


/**
 * Set selected county
 *
 * @param store
 * @param countyFips
 */
function setCounty(store, countyFips) {
  const county = store.dict[+countyFips];

  // Fail safe
  if (!county){
    return store;
  }

  const selected = {
    ...county,
    name: county[countyNameKey],
    state: county[stateAbbrKey],
    fips: county[countyFipsKey]
  };

  return {
    ...store,
    selected
  }
}

function getCountyList(data) {
  return _.chain(data)
    .map(county => {
      return {
        name: county[countyNameKey],
        state: county[stateAbbrKey],
        fips: county[countyFipsKey]
      }
    })
    .uniqBy('fips')
    .orderBy('name')
    .value();
}

/**
 * Set initial data and loading false
 *
 * @param store
 * @param data
 */
function setData(store, data) {
  return {
    ...store,
    loading: false,
    data: data,
    list: getCountyList(data),
    dict: _.keyBy(data, countyFipsKey)
  };
}

function setPercentileData(store, data) {
  return {
    ...store,
    loadingPct: false,
    percentiles: data,
    percentileDict: _.keyBy(data, countyFipsKey)
  };
}

function clearData(store) {
  return {
    ...store,
    // loading: true,
    loadingPct: true
  };
}

export default (store = defaults, action) => {
  switch (action.type) {
    case types.STATE_DATA_RECEIVED:
      return setData(store, action.data);
    case types.STATE_PCT_DATA_RECEIVED:
      return setPercentileData(store, action.data);
    case types.SELECT_COUNTY:
      return setCounty(store, action.countyFips);
    case types.GET_STATE_DATA:
      return clearData(store);
    default:
      return store;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/counties-reducer.js